import React, { Component } from "react";

import $ from 'jquery';

import { Modal } from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

$(document).ready(function(){
    $(".react-datepicker-popper").attr("data-placement", "bottom");
});

class PauseProfileModal extends Component {

    constructor() {
        super();

        this.state = {
        }

    }

    render() {

        const {
            isOpen,
            onHide,
            goBack,
            endDate,
            GoOffline,
            startDate,
            onChangeDate,
        } = this.props;

        return (

            <Modal
                centered
                size="lg"
                show={isOpen}
                onHide={onHide}
                className="profile-status-modal"
            >
                <Modal.Header>
                    <button onClick={onHide} data-dismiss="modal" aria-label="Close" className="close">
                        <i className="mdi mdi-close"></i>
                    </button>
                </Modal.Header>
                <Modal.Body>
                    <h4>Pause your tutor profile</h4>
                    <p>
                        Your profile won't show up in tutor search results during the period you set.
                        You'll still be responsible for any confirmed and ongoing lessons.
                    </p>
                    <div className="date-range">
                        <div className="pauseProfile-childdiv">
                            <div className="date">
                                <DatePicker
                                    selectsStart
                                    endDate={endDate}
                                    maxDate={endDate}
                                    minDate={new Date()}
                                    closeOnScroll={true}
                                    startDate={startDate}
                                    dateFormat="dd/MM/yyyy"
                                    shouldCloseOnSelect={false}
                                    showDisabledMonthNavigation
                                    placeholderText="Start date"
                                    onChange={(date) => onChangeDate(date, "offlineStartDate")}
                                    selected={startDate ? new Date(new Date(startDate).getTime()) : null}
                                />
                            </div>
                            <span className="arrow">&#129130;</span>
                            <div className="date">
                                <DatePicker
                                    selectsEnd
                                    endDate={endDate}
                                    closeOnScroll={true}
                                    startDate={startDate}
                                    dateFormat="dd/MM/yyyy"
                                    placeholderText="End date"
                                    showDisabledMonthNavigation
                                    shouldCloseOnSelect={false}
                                    minDate={startDate ? startDate : new Date()}
                                    onChange={(date) => onChangeDate(date, "offlineEndDate")}
                                    selected={endDate ? new Date(new Date(endDate).getTime()) : null}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="buttons">
                        <button className="back" onClick={goBack}>
                            <i className="fa fa-angle-left"></i>Back
                        </button>
                        <button
                            className="button"
                            onClick={GoOffline}
                            disabled={startDate && endDate ? false : true}
                        >
                            Save
                        </button>
                    </div>
                </Modal.Body>
            </Modal>

        );

    }

}

export default PauseProfileModal;